<template>
  <div class="timerSmall">
    <timer-pie :type="props.type" :bar-type="barType" class="timerPie" />
    <timer-numbers :type="props.type" class="timerNumbers" />
  </div>
</template>
<script setup>
import TimerPie from '@/components/TimerPie.vue';
import TimerNumbers from '@/components/TimerNumbers.vue';
const props = defineProps(['type', 'barType']);
</script>
<style scoped lang="scss">
.timerSmall {
  display: flex;
  gap: rem(17px);
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: rem(52px);
}
.timerPie {
  width: rem(52px);
  height: rem(52px);
  flex: 0 0 auto;
}
.timerNumbers {
  display: block;
  flex: 1 1 100%;
  :deep(.unit),
  :deep(.number) {
    display: inline-block;
  }
  :deep(.unit) {
    margin-left: 0.5em;
  }
  :deep(.mins) {
    font-size: rem(70px);
  }
}
</style>
